import React, { useState } from "react";
import { Link } from "react-router-dom";

import useInput from "../../utils/useInput";

const ForgotPassword = () => {
  const [email, bindEmail] = useInput("");

  const [message, setMessage] = useState(null);

  const FormSubmitHandler = async function (e) {
    e.preventDefault();
    let form = { email };

    await fetch("https://atease-insurance.herokuapp.com/user/password/reset", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === "FAILED") {
          setMessage(data.message);
          setTimeout(() => {
            setMessage(null);
          }, 3000);
        } else {
          if (data.status === "SUCCESS") {
            setMessage(data.message);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <div className="limiter mt-vh-20">
        <div className="container-login100">
          <div className="wrap-login100">
            <form
              onSubmit={FormSubmitHandler}
              className="login100-form validate-form"
            >
              <span className="login100-form-title">Forgot Your Password?</span>

              <p className="text-center mt-5 mb-3">
                Type in your email address to send a one-time-password (OTP)
                with which to reset your password
              </p>

              <div
                className="wrap-input100 validate-input"
                data-validate="Email is required"
              >
                <span className="label-input100">Email</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type your email"
                  {...bindEmail}
                />
                <span className="focus-input100 email"></span>
              </div>

              {message && <p className="text-center p-t-100">{message}</p>}

              <div className="container-login100-form-btn p-t-100">
                <div className="wrap-login100-form-btn">
                  <div className="login100-form-bgbtn"></div>
                  <button className="login100-form-btn">Send</button>
                </div>
              </div>

              <div className="flex-col-c p-t-100">
                <Link to="/resetpassword" className="txt2">
                  Click to go to Reset Page
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
